import React, {FC, ReactElement} from 'react';
import {IconProps} from './Icon';

const isLocalIcon = (name: string): boolean => {
    try {
        require(`./icons/${name}`);
        return true;
    } catch (e) {
        return false;
    }
};

const DynamicIcon: FC<IconProps> = ({name, className}): ReactElement | null => isLocalIcon(name)
    ? <img src={require(`./icons/${name}`).default} className={className} alt={''}/>
    : <img src={/^(https?:\/\/)/igm.test(name) ? name : `/img/${name}`} className={className} alt={''}/>;

export default DynamicIcon;
